import { css } from 'linaria';
import { styled } from 'linaria/react';

export const descriptionBlock = css`
  position: relative;
  width: 100%;
  padding: 32px;
  margin-bottom: 24px;
  overflow: hidden;
  border-radius: var(--rounding-l);
`;

export const descriptionBlockStylesMap: Record<string, string> = {
  design: css`
    background-color: #C9D8D8;
  `,
  sharm: css`
    background-color: #D8C9C9;
  `,
  neo: css`
    background-color: #D0C9D8;
  `,
  nature: css`
    background-color: #CDD8C9;
  `,
};

export const descriptionBlockWrapper = css`
  @media (--only-largeDesktop) {
    width: 828px;
  }
`;

export const descriptionBlockTitle = css`
  margin-bottom: 12px;
`;

export const descriptionBlockName = css`
  margin-bottom: 16px;
`;

export const DescriptionBlockPattern = styled.div`
  @media (--from-desktop) {
    position: absolute;
    top: 0;
    right: 0;
    width: 288px;
    height: 100%;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: 66px solid transparent;
      border-left: 66px solid;
      content: '';
    }
  }
`;

export const descriptionBlockPatternStylesMap: Record<string, string> = {
  design: css`
    background-color: #AFC4C5;

    &::after {
      border-left-color: #C9D8D8;
    }
  `,
  sharm: css`
    background-color: #C5AFAF;

    &::after {
      border-left-color: #D8C9C9;
    }
  `,
  neo: css`
    background-color: #BBAFC5;

    &::after {
      border-left-color: #D0C9D8;
    }
  `,
  nature: css`
    background-color: #B6C5AF;

    &::after {
      border-left-color: #CDD8C9;
    }
  `,
}
